import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "../../../components/header/Header";
import { ArtistCard } from "../../../components/artist/ArtistCard";
import { useDispatch, useSelector } from "react-redux";
import { getUserListThunk } from "../../../slices/artists/thunk";
import { createSelector } from "@reduxjs/toolkit";
import { getRole } from "../../../utils/GetRole";

export const ArtistsList = () => {

  const dispatch = useDispatch();

  // Selector for user state
  const selectArtistState = (state) => state.user;
  const artistSelector = createSelector(selectArtistState, (artist) => ({
    isLoading: artist.isLoading,
    users: artist.users,
  }));

  const { isLoading, users } = useSelector(artistSelector);
  const fileUrl = process.env.REACT_APP_FILE_URL;

  const [role, setRole] = useState(getRole());
  const [activeTab, setActiveTab] = useState(2); // Default: Artists

  // Fetch user list whenever active tab changes
  useEffect(() => {
    dispatch(getUserListThunk({ userType: 2, isInHouseArtist: activeTab }));
  }, [dispatch, activeTab]);

  // Map user data for artist cards
  const cardsData =
    users?.map((user) => ({
      id: user.id,
      name: user.name,
      userType:"artist",
      image: user.image ? `${fileUrl}/${user.image}` : null,
    })) || [];

    // console.log(cardsData);

  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color">
        <Header name="" />
      </header>

      <div className="w-full mx-auto bg-[#F7F7F7]">
        <div className="w-full">
          <div className="w-full flex items-center justify-between mt-4">
            <span className="font-bold text-black text-[22px] font-grotesk">
              Artists
            </span>

            {role === "admin" && (
              <Link
                to="/admin/create-artist"
                className="bg-primary text-white px-4 py-2 rounded-lg shadow hover:bg-primary/90 transition"
              >
                Add Inhouse Artist
              </Link>
            )}
          </div>

          {/* Tabs */}
          <div className="my-4 flex items-center justify-center tabs">
            <div className="bg-white rounded-lg p-1 shadow-sm flex gap-3 border-border_color border">
              <button
                onClick={() => setActiveTab(2)}
                className={`p-2 rounded-md font-normal font-grotesk text-xs transition-all shadow-[0_4.893px_12.234px_0_rgba(0,0,0,0.05)] min-w-[86px] border border-border_color ${
                  activeTab === 2
                    ? "bg-primary text-white"
                    : "bg-white text-black"
                }`}
              >
                Artists
              </button>

              <button
                onClick={() => setActiveTab(1)}
                className={`p-2 rounded-md font-normal font-grotesk text-xs transition-all shadow-[0_4.893px_12.234px_0_rgba(0,0,0,0.05)] min-w-[86px] border border-border_color ${
                  activeTab === 1
                    ? "bg-primary text-white"
                    : "bg-white text-black"
                }`}
              >
                In-House Artists
              </button>
            </div>
          </div>

          {/* Artist Cards */}
          <div className="w-full mt-6 mb-5">
            {isLoading ? (
              <div className="w-full mx-auto grid gap-3 sm:gap-4 grid-cols-1 xs:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6" aria-busy="true">
                {Array.from({ length: 8 }).map((_, idx) => (
                  <div key={idx} className="w-full border border-border_color p-3 rounded-xl animate-pulse">
                    <div className="w-full h-[192px] rounded bg-gray-200" />
                    <div className="mt-[6px]">
                      <div className="h-4 bg-gray-200 rounded w-3/5 mb-2" />
                      <div className="h-3 bg-gray-200 rounded w-2/5" />
                      <div className="flex items-center justify-center gap-2 w-full mt-3">
                        <div className="h-10 bg-gray-200 rounded w-full" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : cardsData && cardsData.length > 0 ? (
              <ArtistCard artists={cardsData} role={role} />
            ) : (
              <p className="text-center text-gray-500">No artists found</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
